module.exports = __webpack_public_path__ + "img/item4.4f809693.png";